import { useEffect, useSyncExternalStore } from "react";
import { useLocation } from "react-router";
import { useUserHook } from "../hooks/UserHook";
import { isChangelogDialogOpen, subscribeChangelogDialog } from "../components/ui/ChangelogDialog";
import { isDisplayNameDialogOpen, subscribeDisplayNameDialog } from "../components/ui/DisplayNameDialog";
import { getTourForPath } from "./tourDefinitions";
import { areAutoToursSuppressed, getTourRevision, isTourActive, isTourSeen, startTour, subscribeTours } from "./tourRunner";

// Kurzer Aufschub, damit die Seite (Sidebar-Animation, Lazy-Inhalte) steht, bevor die Tour misst.
const START_DELAY_MS = 700;

// In PageMasterTemplate gemountet. Reihenfolge beim ersten Login (Masterplan Paket 6):
// Beta-/Changelog-Dialog -> Anzeigename-Popup (Paket 5) -> Willkommens-Tour -> je Tool
// beim ersten Besuch die Kurz-Tour.
export const TourHost = () => {
    const [user] = useUserHook();
    const { pathname } = useLocation();
    const dialogOpen = useSyncExternalStore(subscribeChangelogDialog, isChangelogDialogOpen);
    const tourRevision = useSyncExternalStore(subscribeTours, getTourRevision);
    const nameDialogOpen = useSyncExternalStore(subscribeDisplayNameDialog, isDisplayNameDialogOpen);

    useEffect(() => {
        if (!user || dialogOpen || nameDialogOpen || isTourActive() || areAutoToursSuppressed()) return;
        const timer = setTimeout(() => {
            if (isChangelogDialogOpen() || isDisplayNameDialogOpen() || isTourActive()) return;
            if (!isTourSeen('welcome')) {
                startTour('welcome');
                return;
            }
            const toolTour = getTourForPath(pathname);
            if (toolTour && !isTourSeen(toolTour)) startTour(toolTour);
        }, START_DELAY_MS);
        return () => clearTimeout(timer);
    }, [user, dialogOpen, nameDialogOpen, pathname, tourRevision]);

    return null;
};

// "Tour starten" im User-Menue: Tool-Tour der aktuellen Seite, sonst die Willkommens-Tour.
export const startTourForPath = (pathname: string) => {
    startTour(getTourForPath(pathname) ?? 'welcome');
};
